import React, { createContext, useContext, useState, useEffect } from "react";
import { useApi } from "./ApiClient";
import { useAuth } from "react-oidc-context";

const SessionContext = createContext(null);

export const SessionProvider = ({ children }) => {
  const api = useApi(process.env.REACT_APP_VAF_BASE_URL);
  const auth = useAuth();

  const [session, setSession] = useState();

  useEffect(() => {
    const fetchSessions = async () => {
      try {
        const response = await api.get(`getAllActiveSessions`);
        const data = response.data.data;

        setSession(data);
      } catch (error) {
        console.log("error", error);
      }
    };

    if (auth.user) {
      fetchSessions();
    }
  }, [auth.user]);
  return (
    <SessionContext.Provider value={session}>
      {children}
    </SessionContext.Provider>
  );
};

export const useSession = () => useContext(SessionContext);
